<template>
  <div class="contract-page">
    <div class="top-nav">
      <div class="back-btn" @click="goBack">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </div>
      <div class="title-wrapper">
        <h1 class="title">用户服务协议</h1>
      </div>
    </div>

    <div class="contract-card">
      <h2 class="contract-title">《粤港澳微短剧产业联盟信息服务平台用户服务协议》</h2>
      <div class="meta">版本更新日期：【2026】年【07】月【1】日</div>
      <div class="meta">版本生效日期：【2026】年【07】月【1】日</div>

      <div class="content">
        <p v-for="(line, index) in contractLines" :key="index" :class="getLineClass(line)">
          {{ line }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplyContract',
  data() {
    return {
      contractLines: [
        '欢迎您使用粤港澳微短剧产业联盟短剧产业综合信息服务平台！',
        '本协议是由粤港澳微短剧产业联盟（以下简称本品牌）隶属于粤港澳微短剧产业联盟有限公司，中国大陆唯一运营方为星飞煌（深圳）传媒有限公司，系企业自主运营的产业商业合作品牌，仅作为产业资源对接、项目合作撮合、品牌联合推广的商事协作平台，不属于在民政部门登记的社会团体、行业协会及其他社会组织；与您（以下简称“用户”或“您”）之间，关于您访问、注册、登录、使用【粤港澳微短剧产业联盟】网站、移动应用程序、小程序以及后续开通的其他相关服务（以下统称“本平台”）所订立的权利义务规范。',
        '特别提示：',
        '在点击同意本协议之前，请您务必审慎阅读、充分理解本协议各条款内容，特别是以加粗、下划线或其他合理方式提示您注意的条款，这些条款可能与您的权益有重大利害关系，包括但不限于相关免除或限制责任的条款、争议解决和法律适用条款等。如您对本协议有任何疑问，可通过本平台公示的联系方式与我们联系。',
        '当您按照注册或信息发布页面提示，勾选、点击或以其他方式确认同意本协议，即表示您已充分阅读、理解并接受本协议的全部内容，自愿接受本协议约束，成为本平台用户。如果您不同意本协议的任何内容，或者无法准确理解相关条款的含义，请您立即停止注册、登录或使用本平台。',
        '第一条 服务主体及定义',
        '1.1 本平台由【粤港澳微短剧产业联盟有限公司】旗下星飞煌（深圳）传媒有限公司所有并运营。本公司可能根据平台业务发展，自行决定增加、调整、暂停或终止部分或全部服务，并变更服务提供主体，但会通过合理方式通知您。',
        '1.2 本平台是专注于短剧产业领域的综合服务平台，为短剧行业从业者（包括但不限于编剧、导演、制片方、投资方、发行方、演员、广告主等）及对短剧产业感兴趣的用户提供信息发布与展示、项目对接、行业资讯、在线交流及其他技术支持服务。',
        '1.3 “用户”是指通过本平台注册、登录或使用本平台服务的自然人、法人或其他组织。用户应当具备中华人民共和国法律规定的与其行为相适应的民事行为能力。若您不具备前述民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果，且本公司有权注销或永久冻结您的账户。',
        '第二条 账户注册与使用',
        '2.1 您在使用本平台部分功能（包括但不限于发布短剧项目、招聘信息、合作需求等）前，需注册一个本平台账户。您注册时应根据本平台页面的提示提供真实、准确、完整、合法有效的注册信息（包括但不限于您的姓名/名称、电子邮箱地址、联系电话、联系地址等）。',
        '2.2 您的账户仅限于您本人或本机构使用。您应当对您账户项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、披露项目、进行交易等）负责。若您发现任何未经授权使用您账户的情况或其他安全漏洞，应立即通知本平台。',
        '2.3 您应当妥善保管您的账户信息及密码，因您自身原因（包括但不限于主动泄露、遭受网络攻击、密码设置过于简单等）导致的账户盗用或信息泄露等损失、损害，由您自行承担。',
        '第三条 信息发布与审核',
        '3.1 您有权在本平台允许的范围内，依据本平台相关规则发布与短剧产业相关的合法信息，包括但不限于短剧剧本、项目投资、演员招募、拍摄制作、版权交易、设备租赁、人才求职招聘等信息。',
        '3.2 您承诺并保证，您通过本平台发布的所有信息（包括但不限于文字、图片、视频、音频、链接等）均真实、准确、完整、合法、有效，不侵犯任何第三方的合法权益（包括但不限于知识产权、肖像权、名誉权、隐私权等），不包含任何诽谤、骚扰、淫秽、威胁、恶意、虚假、误导性内容，不违反任何法律法规、政策及公序良俗。',
        '3.3 您了解并同意，本平台有权（但无义务）对您发布的信息进行审核、筛查、监控。本平台有权依据相关法律法规、本协议及平台规则，对不符合要求的信息采取屏蔽、删除、下架、禁止发布等处理措施，且无需事先通知您。本平台的前述审核行为不构成对您发布信息内容的任何保证、承诺或认可，您应对您发布的信息独立承担全部法律责任。',
        '第四条 平台服务规范',
        '4.1 您不得利用本平台从事任何违法违规活动，包括但不限于：',
        '（1）发布、传播或以其他方式展示含有违反国家法律法规、危害国家安全、破坏社会稳定、煽动民族仇恨、宣扬恐怖主义、极端主义、淫秽色情、赌博暴力、欺诈、谣言、虚假信息等内容；',
        '（2）未经他人同意，收集、存储、使用或传播他人个人信息；',
        '（3）冒充他人、利用他人名义发布信息或进行任何操作；',
        '（4）从事任何可能破坏、干扰、攻击、侵入本平台或相关服务器、网络的行为；',
        '（5）从事任何侵犯本平台合法权益或损害本平台良好声誉的行为；',
        '（6）法律法规及本协议禁止的其他行为。',
        '4.2 您通过本平台与第三方进行任何形式的线下接触、谈判、交易或合作，均由您与第三方自行协商并承担全部风险与责任。本平台仅为信息展示与交流平台，不对您与第三方之间的任何口头或书面协议、交易、合作进行任何形式的担保、参与或负责。',
        '第五条 知识产权',
        '5.1 您在本平台发布的信息（包括但不限于文字、图片、视频、音频等）的知识产权归您或相关权利人所有。您授予本平台一项全球范围内、免费、非独家的使用许可，使得本平台能够对您发布的信息进行存储、展示、传播、复制、修改、翻译、汇编、分发、创作衍生作品等，以便为您提供本协议项下的服务。',
        '5.2 本平台自身的源代码、软件、设计、版面、商标、标识、图表、域名等知识产权及相关权益，均归本公司所有。未经本公司书面同意，您不得以任何形式复制、仿冒、使用或意图获得该等知识产权。',
        '5.3 若您认为您的知识产权或其他合法权益在本平台受到侵犯，您可以通过本平台公示的联系方式提交权利通知，我们将依据相关法律规定及时处理。',
        '第六条 用户信息保护与隐私政策',
        '6.1 本公司非常重视用户个人信息的保护。您在注册、使用本平台服务过程中，我们可能会收集和使用您的相关信息。我们将采取安全保护措施，保护您的个人信息免遭泄露、篡改、毁损或丢失。',
        '6.2 关于我们如何收集、使用、存储、共享和保护您的个人信息，以及您所享有的相关权利，请详细阅读《平台隐私政策》。该隐私政策是本协议不可分割的一部分，与本协议具有同等法律效力。您同意本协议即视为您已经理解并接受该隐私政策的全部内容。',
        '第七条 免责声明',
        '7.1 本平台依“现状”和“现有”基础提供信息服务。本公司不作任何形式的明示或默示的担保，包括但不限于：',
        '（1）本平台服务将满足您的要求或期望；',
        '（2）本平台服务将不受干扰、及时、安全、无错误或不发生数据丢失；',
        '（3）您通过本平台获取的任何信息（包括第三方发布的信息）的准确性、可靠性、完整性、及时性、合法性；',
        '（4）您与任何第三方之间因本平台服务而产生的任何合作、交易或行为的成功性及后果。',
        '7.2 您通过本平台与第三方发生的任何线下接触、协商、交易、合作等行为，均为您与第三方之间的独立行为。您应自行审慎评估交易风险，并独立承担全部责任。如因此产生任何纠纷、损失或法律责任，均与本公司无关，本公司不承担任何形式的责任。',
        '7.3 对于因下列原因导致本平台服务中断、延迟、错误或无法访问，本公司不承担责任：',
        '（1）因台风、地震、洪水、雷电、火灾、疫情、战争、恐怖袭击等不可抗力事件；',
        '（2）因黑客攻击、病毒入侵、电信部门技术调整或故障、政府管制、网络服务商或设备提供商系统故障等本平台无法预见、控制或避免的原因；',
        '（3）本公司对平台系统或相关设备进行检修、维护、升级、调整。',
        '第八条 协议的变更与终止',
        '8.1 本公司有权根据国家法律法规变化、平台业务调整或运营需要，不时地修改本协议。一旦协议内容发生变更，我们将会通过平台公告、站内信、弹窗等方式通知您。如果您不同意变更后的协议，您有权停止使用本平台服务。如果您继续使用本平台服务，则视为您已经接受变更后的协议。',
        '8.2 您有权通过注销账户或停止使用本平台服务的方式终止本协议。您理解并同意，注销账户后，本平台没有义务保留或向您提供您账户中的任何信息。',
        '8.3 本公司有权依据本协议约定或相关法律法规规定，对违反本协议的用户采取警告、限制或禁止使用部分或全部功能、封禁或注销账户、删除违规信息等措施，并保留追究您相关法律责任的权利。',
        '第九条 法律适用与争议解决',
        '9.1 本协议的订立、生效、履行、解释及争议解决均适用中华人民共和国大陆地区法律（不包括冲突法规则）。',
        '9.2 因本协议引起或与本协议有关的任何争议，您与本公司应首先通过友好协商解决。协商不成的，任何一方均有权将争议提交至本公司住所地有管辖权的人民法院通过诉讼方式解决。',
        '第十条 其他',
        '10.1 本协议条款的任何部分被认定为无效或不可执行，不影响其余部分的效力。',
        '10.2 本公司未行使或执行本协议中的任何权利或规定，不构成对该权利或规定的放弃。',
        '10.3 本协议中的所有标题仅为阅读方便，不具有任何法律或合同效力。',
        '10.4 如果您对本协议有任何疑问、意见或建议，可以通过以下方式与我们联系：',
        '客服邮箱：【msdia7@163.com】',
        '联系地址：【广东省深圳市南山区深国际前海颐都大厦5层】',
        '客服电话：【19200202961】',
        '（以下无正文）'
      ]
    }
  },
  methods: {
    getLineClass(line) {
      if (/^第[一二三四五六七八九十]+条/.test(line) || line === '特别提示：') return 'section-line'
      if (/^（\d+）/.test(line)) return 'sub-line'
      return ''
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.replace('/apply/first')
      }
    }
  }
}
</script>

<style scoped>
.contract-page {
  min-height: 100vh;
  background: #f8fafc;
  padding-bottom: 100px;
  font-size: 12px;
}
.top-nav {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 10;
}
.back-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 11;
}
.title-wrapper {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}
.contract-card {
  margin: 16px 20px;
  padding: 20px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 6px 18px rgba(31, 45, 61, 0.06);
}
.contract-title {
  margin: 0 0 12px;
  color: #1a1a1a;
  font-size: 17px;
  line-height: 1.5;
  text-align: center;
}
.meta {
  color: #86909c;
  font-size: 12px;
  line-height: 1.8;
  text-align: center;
}
.content {
  margin-top: 18px;
}
.content p {
  margin: 0 0 12px;
  color: #333;
  font-size: 13px;
  line-height: 1.8;
  text-align: justify;
  word-break: break-word;
}
.content .section-line {
  margin: 20px 0 12px;
  color: #165DFF;
  font-size: 15px;
  font-weight: 700;
}
.content .sub-line {
  padding-left: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/join/contract.vue